import React, { useEffect, useState } from 'react';
import './SummaryTab.scss';
import Button from '../../BaseComponents/Button';
import SummaryModal from './SummaryModal';
import SummaryListTable from './SummaryListTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import {
  changeHealthSummaryModalVisibility,
  setHealthSummariesList,
} from '../../../store/memberSlice';
import { getMemberHealthSummaryList } from '../../../api/healthSummary';
import Loader from '../../BaseComponents/Loader';

const Summary = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any | null>(null);

  const { isHealthSummaryModalOpened } = useSelector(
    (state: RootState) => state.member
  );

  useEffect(() => {
    const fetchHealthSummary = async () => {
      try {
        setIsLoading(true);
        const resp = await getMemberHealthSummaryList(
          window.location.pathname.split('/')[2]
        );
        dispatch(setHealthSummariesList(resp.health_summaries));
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHealthSummary();
  }, [dispatch]);

  if (isLoading) return <Loader />;
  if (error) return <div>Error loading diet diary</div>;

  return (
    <div className='summary-container'>
      <div className='summary-header-row'>
        <div className='sum-counter'></div>
        <Button
          isSecondary={true}
          text='Add Summary'
          onClick={() => dispatch(changeHealthSummaryModalVisibility(true))}
        />
      </div>
      <SummaryListTable />
      <SummaryModal
        isOpen={isHealthSummaryModalOpened}
        onClose={() => dispatch(changeHealthSummaryModalVisibility(false))}
      />
    </div>
  );
};

export default Summary;
